// Links to the legal pages on chefi.ceberon.ch (privacy, terms, refunds, imprint, open source).
// They open in the browser (Telegram's own browser inside the Mini App); each page is in English and
// German, and the German part is opened directly when the app speaks German.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListItem } from './ui';
import { telegram } from '../platform/telegram';

export const LEGAL_SITE = 'https://chefi.ceberon.ch/legal';
export const LEGAL_PAGES = ['privacy', 'terms', 'refunds', 'imprint', 'openSource'] as const;
export type LegalPage = (typeof LEGAL_PAGES)[number];
const PATHS: Record<LegalPage, string> = { privacy: 'privacy', terms: 'terms', refunds: 'refunds', imprint: 'imprint', openSource: 'open-source' };

export const legalUrl = (page: LegalPage, language: string) => `${LEGAL_SITE}/${PATHS[page]}${language.startsWith('de') && page !== 'openSource' ? '#de' : ''}`;

export default function LegalLinks({ pages = LEGAL_PAGES }: { pages?: readonly LegalPage[] }) {
  const { t, i18n } = useTranslation();
  return (
    <>
      {pages.map(page => (
        <ListItem key={page} title={t(`legal.${page}`)} icon="info" onPress={() => telegram.openLink(legalUrl(page, i18n.language))} />
      ))}
    </>
  );
}
